module.exports = __webpack_public_path__ + "img/SHAWS-WM.1dfbbf93.png";